import { defineComponent as _defineComponent } from 'vue'
import { useRirekishoPreview } from '@/composables/format-edit/useRirekishoPreview'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EntrySheetPreview',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean };



const {
  reason,
  reasonNew,
  addressFurigana,
  checkValid,
  formLib,
  scaleStyle,
  highlightMessage,
  goCardTo,
  highLightClass,
  classObject,
  errorMessages,
  age,
  formatedCreateDate,
  eduJobHistoryTable4New,
  optionItems
} = useRirekishoPreview(props, {
  maxEduJobRows: 11,
  maxLicenseRows: 5,
  textareaMaxHeights: {
    reason: 70,
    reasonNew: 70,
    studyHistory: 70,
    clubActivity: 70,
    parttimeJob: 70,
    licenseHistory: 30,
    skillList: 30
  },
  useEduJobTable4New: true
})

expose({
  checkValid,
  errorMessages,
  optionItems,
  reason,
  reasonNew,
  addressFurigana
})

return { __sfc: true,props, reason, reasonNew, addressFurigana, checkValid, formLib, scaleStyle, highlightMessage, goCardTo, highLightClass, classObject, errorMessages, age, formatedCreateDate, eduJobHistoryTable4New, optionItems }
}

})